export const getDevice = () => {
  // lowercaseにした方がいいと思うんだけど・・・
  var ua = navigator.userAgent;
  if (
    ua.indexOf('iPhone') > 0 ||
    ua.indexOf('iPod') > 0 ||
    (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)
  ) {
    return 'sp';
  } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
    return 'tab';
  } else {
    return 'pc';
  }
};

/**
 * 使用デバイスがPCか判別する
 */
export const isPc = () => {
  var device = getDevice();
  return device === 'pc';
};

export const getResponsiveSize = () => {
  const val = window.innerWidth;
  if (val >= 1024) {
    return 'PC';
  } else if (val < 1024) {
    return 'TB';
  }
  // if ( val >= 1280 ) {                  return "HD"; } else
  // if ( val < 1280 && val >= 1024 ) {    return "PC"; } else
  // if ( val < 1024 && val >= 568 ) {     return "TB"; } else
  // if ( val < 568 ) {                    return "SP"; }
};

export const enableTouch = () => {
  return 'ontouchstart' in window;
};



// WEBPACK FOOTER //
// ./src/utilities/tabletUtil.js